var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',_vm._l((_vm.question.answer),function(answer){return _c('li',{key:answer.key},[_c('span',{staticClass:"sub-title"},[_vm._v("\n            "+_vm._s(answer.name)+"\n        ")]),_c('VerticalAnalysis',{attrs:{"question":answer,"contain":_vm.contain || ''},on:{"set-patient":_vm.setPatient}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }